import { haptics } from '../platform/telegram'
import { useT } from '../platform/i18n/useT'
import type { TKey } from '../platform/i18n/i18nContext'
import './NavBar.css'

/**
 * Нижняя навигация. Вариант Floating rail.
 * Единственная яркая деталь в спокойном интерфейсе Paper.
 */

export type Tab = 'today' | 'games' | 'progress'

const TABS: ReadonlyArray<{ id: Tab; key: TKey }> = [
  { id: 'today', key: 'nav.today' },
  { id: 'games', key: 'nav.games' },
  { id: 'progress', key: 'nav.progress' },
]

interface Props {
  active: Tab
  onChange: (tab: Tab) => void
}

export function NavBar({ active, onChange }: Props) {
  const { t } = useT()

  const handle = (tab: Tab) => {
    if (tab === active) return
    haptics.select()
    onChange(tab)
  }

  return (
    <nav className="navbar" aria-label={t('app.name')} role="tablist">
      {TABS.map(({ id, key }) => (
        <button
          key={id}
          role="tab"
          aria-selected={id === active}
          className={id === active ? 'navbar__tab navbar__tab--on' : 'navbar__tab'}
          onClick={() => handle(id)}
        >
          {t(key)}
        </button>
      ))}
    </nav>
  )
}
